import React,{ Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { resetPass } from '../actions'

class ResetPass extends Component{
  
  constructor(props) {
    super(props);
    this.state = {
      correo:"",
      estadosMsj:["","alert-succes","","alert-danger"]
    }
    this.cambia = this.cambia.bind(this)
  	}

	cambia = (key,value)=>{
		this.setState({[key]:value})
	}

	enviaLogin = (e) => {
    this.props.resetPass(this.state.correo)
	}

	componentDidMount(){
    	
  	}

	componentDidUpdate(prevProps, prevState){

  	}

	render(){
		return (
			 <div className="container">
			 	{ this.props.usuario.msj.contenido != "" && 
			 		<div className={"alert "+this.state.estadosMsj[this.props.usuario.msj.tipo]} role="alert">{ this.props.usuario.msj.contenido }</div>
				}
			 	<h1 className="display-4">CAMBIAR CONTRASEÑA</h1>
		         <form>
				  <div className="form-group">
				    <label >E-Mail</label>
				    <input type="email" className="form-control" id="usuario" aria-describedby="emailHelp" placeholder="Ingresa tu email" onChange={evt => this.cambia('correo',evt.target.value)}/>
				    
				  </div>
				 	<button type="button" className="btn btn-info m-2" onClick={this.enviaLogin}>ENVIAR</button>
	        		<button type="button" className="btn btn-info m-2" onClick={(e)=>this.props.history.push("/registro")}>REGISTRATE</button>
	        		<button type="button" className="btn btn-info m-2" onClick={(e)=>this.props.history.push("/login")}>LOGUEARME</button>
				</form>
			</div>
		)
	}

};

const mapStateToProps = (state, ownProps) => {
  return {
      usuario: state.usuario
    }
}

const mapDispatchToProps = dispatch => {
  return {
    resetPass: (user) => {
      dispatch(resetPass(user))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPass)



// WEBPACK FOOTER //
// ./src/containers/reset.js